if (!(window as any).global) {
    (window as any).global = window;
}
(window as any).__Zone_enable_cross_context_check = true;
